

















import ChosenImage from "@/components/ChosenImage.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import { Component, Vue } from "vue-property-decorator";
import IAvatar from "../typings/IAvatar";

/**
 * The last view, displayed after submitting a completed survey.
 */
@Component({
  components: { ChosenImage, ProgressBar }
})
export default class Complete extends Vue {
  /**
   * The progress bar's current progress level.
   */
  private get progress(): number {
    return this.$store.getters.progress;
  }

  private mounted(): void {
    // navigate back to attract after completion
    setTimeout(() => {
      this.$router.push("/");
    }, 6000);
  }
}
